import {nameofFactory} from 'web-app/util/typescript';

export interface CreateEmployeeFormData {
    name: string;
    groupId: string;
    email?: string;
    employeeRoleId?: string;
    addAnother: boolean;
}

export const fieldNames = nameofFactory<CreateEmployeeFormData>();
